<div *ngIf="!isAuthInitialized" class="loading-container">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Initializing...</p>
  </div>
</div>

<router-outlet *ngIf="isAuthInitialized"></router-outlet>
